import(/* webpackMode: "eager" */ "/app/app/(web)/error.tsx");
